// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestSessionId } from './HarvestSession';
import { harvestOperationTemplateId } from './HarvestOperationTemplate';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestStageId = (z.number());
export const harvestStage = z.object({
    id: harvestStageId,
    harvest_session_id: harvestSessionId,
    template_id: harvestOperationTemplateId,
    name: z.string().nullable(),
    sort_order: z.number(),
    auto_key: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const harvestStageInitializer = z.object({
    id: harvestStageId.optional(),
    harvest_session_id: harvestSessionId,
    template_id: harvestOperationTemplateId,
    name: z.string().optional().nullable(),
    sort_order: z.number().optional(),
    auto_key: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const harvestStageMutator = z.object({
    id: harvestStageId.optional(),
    harvest_session_id: harvestSessionId.optional(),
    template_id: harvestOperationTemplateId.optional(),
    name: z.string().optional().nullable(),
    sort_order: z.number().optional(),
    auto_key: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=HarvestStage.js.map